export default __webpack_public_path__ + "static/media/Homepage-Circle-Graphic-1.dda7f851.png";